
<div
  class="cmp-order-stepper row justify-center full-width ws-typography relative-position cy-sticky"
  :style="stepperStyle"
  :class="{ backdropped: editBackdropActive }"
>
  <div class="container full-width">
    <div
      class="row no-wrap ws-invisible-scrollbar"
      :class="{ 'justify-between': !usingAdminTheme, 'justify-evenly': usingAdminTheme }"
    >
      <template
        v-for="(step, index) in visibleSteps"
      >
        <div v-if="usingAdminTheme && index > 0" :key="index" class="divider"></div>
        <div
          :key="step"
          class="col col-auto ellipsis text-center"
        >
          <button
            class="nav-link composite-text ws-typo-button-sm"
            :class="{
              'enabled cursor-pointer': stepEnabled(step),
              'current': usingAdminTheme && isCurrentStep(step),
              'text-normal': usingAdminTheme
            }"
            :disabled="!stepEnabled(step)"
            :tabindex="0"
            @click="stepEnabled(step) && navigateToStep(step, false)"
            @keydown.enter="stepEnabled(step) && navigateToStep(step, false)"
          >
            <ws-icon
              v-if="usingAdminTheme && stepEnabled(step) && !isCurrentStep(step)"
              name="success"
              :size="24"
              color="green"
              class="q-mr-sm"
            ></ws-icon>
            <span v-else :class="{'circle q-mr-sm': usingAdminTheme}">
              {{ index + 1 }}<template v-if="!usingAdminTheme">.&nbsp;</template>
            </span>
            <span>
              {{ $t(getKey(step)) }}
            </span>
          </button>

          <div v-if="!usingAdminTheme" class="progress-wrap q-mt-xs q-mx-auto">
            <div
              class="progress"
              :style="'width: ' + progressByUser[step] + '%'"
            ></div>
            <div
              class="rest"
              :style="'width: ' + (100 - progressByUser[step]) + '%'"
            ></div>
          </div>
        </div>
      </template>
    </div>
  </div>
</div>
